const INIT_KEY = '__norkayaWishlistDialogInit__';

if (!window[INIT_KEY]) {
    window[INIT_KEY] = true;

    class WishlistDialog extends HTMLElement {
        connectedCallback() {
            this.timerId = 0;
            this.dialog = this.querySelector('dialog');
            this.textElement = this.querySelector('[data-wishlist-modal-text]');
            this.closeButton = this.querySelector('[data-wishlist-dialog-close]');

            this.handleCloseClick = this.handleCloseClick.bind(this);
            this.handleCancel = this.handleCancel.bind(this);

            this.closeButton?.addEventListener('click', this.handleCloseClick);
            this.dialog?.addEventListener('cancel', this.handleCancel);
        }

        disconnectedCallback() {
            window.clearTimeout(this.timerId);

            this.closeButton?.removeEventListener('click', this.handleCloseClick);
            this.dialog?.removeEventListener('cancel', this.handleCancel);
        }

        get messages() {
            return {
                added: this.dataset.wishlistAddedMessage || 'Added to wishlist',
                removed: this.dataset.wishlistRemovedMessage || 'Removed from wishlist',
            };
        }

        handleCloseClick(event) {
            event.preventDefault();
            event.stopPropagation();

            this.closeDialog();
        }

        handleCancel() {
            this.closeDialog();
        }

        openToast(type = 'added', duration = 2500) {
            if (!this.dialog) return;

            const message = type === 'removed' ? this.messages.removed : this.messages.added;

            if (this.textElement) {
                this.textElement.textContent = message;
            }

            window.clearTimeout(this.timerId);

            this.dialog.classList.remove('is-closing');
            this.dialog.style.display = '';
            this.dialog.style.opacity = '';
            this.dialog.style.pointerEvents = '';

            if (!this.dialog.open) {
                this.dialog.showModal();
            }

            this.timerId = window.setTimeout(() => {
                this.closeDialog();
            }, duration);
        }

        closeDialog() {
            window.clearTimeout(this.timerId);

            if (!this.dialog) return;

            this.dialog.classList.add('is-closing');
            this.dialog.style.opacity = '0';
            this.dialog.style.pointerEvents = 'none';

            window.setTimeout(() => {
                if (!this.dialog) return;

                if (this.dialog.open) {
                    this.dialog.close();
                }

                this.dialog.classList.remove('is-closing');
                this.dialog.style.opacity = '';
                this.dialog.style.pointerEvents = '';
            }, 180);
        }
    }

    if (!customElements.get('wishlist-dialog')) {
        customElements.define('wishlist-dialog', WishlistDialog);
    }
}